
import { Component, EventEmitter, Input, OnInit, SimpleChanges, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';

import { FilesActions } from 'src/app/common/store/actions/files.actions';


import { selectCurrentFileData, selectDocumentsFolderByCarId } from 'src/app/common/store/state/app.state';
import { FormBuilder, Validators } from '@angular/forms';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { GeneralBasicData, CarDocumentType } from 'src/app/public/common/constants/general-basic-data';
import { FileData } from 'src/app/public/common/models/file-data.model';

@Component({
    selector: 'app-insure-quote',
    templateUrl: './insure-quote.component.html',
    styleUrls: ['./insure-quote.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class InsureQuoteComponent implements OnInit {

  //documentTypesBD : any [] = GeneralBasicData.getAllCarDocumentTypes();

  carDocumentTypesBD : any [] = GeneralBasicData.carDocumentTypes;
  selectedCarDocumentType = this.carDocumentTypesBD[0];

  carDocumentsFolder$: Observable<FileData[] | undefined > ;
  carDocumentsFolder: FileData[] = [];

  currentFileData$: Observable<FileData> ;
  currentFileData: FileData[] = [];

  currentDocument: any;
  
  fetchingDocument: boolean = true;

  selectedFiles: File[] = [];

  firstFormGroup = this._formBuilder.group({
    firstCtrl: [],
  });
  secondFormGroup = this._formBuilder.group({
    secondCtrl: ['', Validators.required],
  });
  
  isEditable = true;

  constructor(
    private router: Router,
    private store: Store, 
    private readonly sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private _formBuilder: FormBuilder) {

        this.carDocumentsFolder$ = store.select(selectDocumentsFolderByCarId("0"));
        this.currentFileData$ = store.select(selectCurrentFileData);

    }

  ngOnInit(): void {

    this.carDocumentsFolder$.subscribe(
        (result) =>  {
            this.carDocumentsFolder = result!;
        }

    );

    this.currentFileData$.subscribe(
      (result) =>  {
          //this.carDocumentsFolder = result!;
      }

    );

  }

  moneyFormat(s: string): string{
    return AppFunctions.numberWithSpaces(s);
  }

  dateFormat(dt: string): string{

    return AppFunctions.stringToDatetime(dt);
  }

  createImageFromBlob(imageData: Blob): any {
    let objectUrl = URL.createObjectURL(imageData);     
    return this.sanitizer.bypassSecurityTrustUrl(objectUrl);    
  }

  getCarDocument(i: number): any{

    if(this.carDocumentsFolder != undefined && this.carDocumentsFolder.length > 0 ){
      let objectUrl = URL.createObjectURL(this.carDocumentsFolder[i].blob);     
      return this.sanitizer.bypassSecurityTrustUrl(objectUrl); 
    }
  }

  getSeletedDocument(i: number): any{

    if(this.carDocumentsFolder != undefined && this.carDocumentsFolder.length > 0 ){
      let objectUrl = URL.createObjectURL(this.carDocumentsFolder[i].blob);     
      return this.sanitizer.bypassSecurityTrustUrl(objectUrl); 
    }
  }

  selectFiles (event: any): void {

    this.selectedFiles = event.target.files;
    //console.log('file name = '+files[0].name);

    if(this.selectedFiles != undefined && this.selectedFiles.length > 0 ){
        let objectUrl = URL.createObjectURL(this.selectedFiles[0]);     
        this.currentDocument = this.sanitizer.bypassSecurityTrustUrl(objectUrl); 
      }

  }

  convertDocument (carDocumentType: CarDocumentType, index: number): void {

    if(this.selectedFiles.length > 0 && this.selectedFiles[0] != undefined ){
      this.store.dispatch(FilesActions.convertDocumentSubmit({ carDocumentType: carDocumentType, file: this.selectedFiles[index] }));
    }
  }
  

  uploadDocument (index: number): void {

    if(this.selectedFiles.length > 0 && this.selectedFiles[0] != undefined ){
      this.store.dispatch(FilesActions.uploadCarDocumentSubmit({ carId: "0", file: this.selectedFiles[index] }));
    }
  }

  onDocumentTypeChange(){

  }

  toJson(input: any): any{
    return JSON.stringify(input, null, 4);
  }

}

